module.exports = __webpack_public_path__ + "img/ImGletscher.9b221e07.jpg";